export function groupAgencies(data) {

  let groups = [...new Set(data.map(i => i.groupe))];

  let groupData = []

  groups.forEach((e) => {
    let elements = data.filter((f) => { return f.groupe == e })
    let groupedPopulation = elements.reduce((acc, obj) => { return acc + obj.population }, 0);
    let groupedArea = elements.reduce((acc, obj) => { return acc + obj.superficie }, 0);
    groupData.push({
      groupe: e,
      color: elements[0].color,
      country: elements[0].country,
      region: elements[0].region,
      timezone: elements[0].timezone,
      population: groupedPopulation,
      superficie: groupedArea
    })
  })

  return groupData

}


export function dataFormat(data, selectedKey, geoData, groupData, t) {

  let result = [];

  let kpiKeys = Object.keys(data[0]);

  kpiKeys.splice(0, 3);

  let sortedKpis = data.sort((a, b) => b[selectedKey] - a[selectedKey]);
  let kpisWithoutAvgs = sortedKpis.filter((e) => { return e.groupe !== e.region && e.groupe !== e.country });

  //Region kpis
  let kpiRegAvgs = sortedKpis.filter((e) => { return e.groupe == e.region });

  //Array values for map color gradient
  let kpiRegVals = kpiRegAvgs.map(i => i[selectedKey]).sort(function (a, b) { return a - b });

  //Country kpis
  let kpiCounAvgs = sortedKpis.filter((e) => { return e.groupe == e.country });

  let translated = translateAll(kpiKeys, t);

  //Bubble Chart Data
  let bubbleData = [];
  groupData.forEach((e) => {
    if (kpisWithoutAvgs.find((f) => { return f.groupe == e.groupe })) {
      let kpiVal = kpisWithoutAvgs.length > 0 ? kpisWithoutAvgs.find((f) => { return f.groupe == e.groupe })[selectedKey] : [];
      bubbleData.push({
        x: e.population,
        y: e.superficie,
        z: kpiVal,
        optc: e.groupe
      })
    }
  })

  //Map Data
  let geoKpiFeatures = [];
  geoData.features.forEach((e, i) => {
    let region = e.properties.region;
    let kpiValue = kpiRegAvgs.find((f) => { return f.groupe == region }) ? kpiRegAvgs.find((f) => { return f.groupe == region })[selectedKey] : '';
    if (kpiValue !== '') {
      geoKpiFeatures.push(e);
      geoKpiFeatures[geoKpiFeatures.length - 1].properties[selectedKey] = kpiValue;
    }
  })

  result =
  {
    'kpisWithoutAvgs': kpisWithoutAvgs,
    'kpiRegAvgs': kpiRegAvgs,
    'kpiRegVals': kpiRegVals,
    'kpiCounAvgs': kpiCounAvgs,
    'bubbleData': bubbleData,
    'geoLayer': { "type": "FeatureCollection", "features": geoKpiFeatures },
    'kpiKeys': translated
  }

  return result;

}




export function translateAll(kpiKeys, t) {

  let translated = []

  kpiKeys.forEach((e) => {

    if (e == "vehicles") {
      translated.push(t('dashboard.kpi.vehicles'))
    }
    if (e == "rtpoints") {
      translated.push(t('dashboard.kpi.datapoints'))
    }
    if (e == "rttrips") {
      translated.push(t('dashboard.kpi.atrips'))
    }
    if (e == "occupancyaverage") {
      translated.push(t('dashboard.kpi.occ'))
    }
    if (e == "rtvehhours") {
      translated.push(t('dashboard.kpi.aveh-h'))
    }
    if (e == "rtvehkms") {
      translated.push(t('dashboard.kpi.aveh-km'))
    }
    if (e == "plannedstoptimes") {
      translated.push(t('dashboard.kpi.stoptimes'))
    }
    if (e == "plannedvehhours") {
      translated.push(t('dashboard.kpi.pveh-h'))
    }
    if (e == "plannedvehkms") {
      translated.push(t('dashboard.kpi.pveh-km'))
    }
    if (e == "plannedtrips") {
      translated.push(t('dashboard.kpi.ptrips'))
    }
    if (e == "maxplanveham") {
      translated.push(t('dashboard.kpi.pveham'))
    }
    if (e == "maxplanvehop") {
      translated.push(t('dashboard.kpi.pvehop'))
    }
    if (e == "maxplanvehpm") {
      translated.push(t('dashboard.kpi.pvehpm'))
    }
    if (e == "maxrtveham") {
      translated.push(t('dashboard.kpi.aveham'))
    }
    if (e == "maxrtvehop") {
      translated.push(t('dashboard.kpi.avehop'))
    }
    if (e == "maxrtvehpm") {
      translated.push(t('dashboard.kpi.avehpm'))
    }
    if (e == "stops") {
      translated.push(t('dashboard.kpi.stops'))
    }
    if (e == "wheelchairstops") {
      translated.push(t('dashboard.kpi.access'))
    }
    if (e == "routes") {
      translated.push(t('dashboard.kpi.routes'))
    }
    if (e == "ontimeperformance") {
      translated.push(t('dashboard.kpi.otp'))
    }
    if (e == "kmpct") {
      translated.push(t('dashboard.kpi.kmpct'))
    }
    if (e == "hpct") {
      translated.push(t('dashboard.kpi.hpct'))
    }
    if (e == "tripspct") {
      translated.push(t('dashboard.kpi.tripspct'))
    }

  })

  return translated

}


export function revertOne(kpi, t) {

  switch (kpi) {
    case t('dashboard.kpi.vehicles'):
      return "vehicles"
    case t('dashboard.kpi.datapoints'):
      return "rtpoints"
    case t('dashboard.kpi.atrips'):
      return "rttrips"
    case t('dashboard.kpi.occ'):
      return "occupancyaverage"
    case t('dashboard.kpi.aveh-h'):
      return "rtvehhours"
    case t('dashboard.kpi.aveh-km'):
      return "rtvehkms"
    case t('dashboard.kpi.stoptimes'):
      return "plannedstoptimes"
    case t('dashboard.kpi.pveh-h'):
      return "plannedvehhours"
    case t('dashboard.kpi.pveh-km'):
      return "plannedvehkms"
    case t('dashboard.kpi.ptrips'):
      return "plannedtrips"
    case t('dashboard.kpi.pveham'):
      return "maxplanveham"
    case t('dashboard.kpi.pvehop'):
      return "maxplanvehop"
    case t('dashboard.kpi.pvehpm'):
      return "maxplanvehpm"
    case t('dashboard.kpi.aveham'):
      return "maxrtveham"
    case t('dashboard.kpi.avehop'):
      return "maxrtvehop"
    case t('dashboard.kpi.avehpm'):
      return "maxrtvehpm"
    case t('dashboard.kpi.stops'):
      return "stops"
    case t('dashboard.kpi.access'):
      return "wheelchairstops"
    case t('dashboard.kpi.routes'):
      return "routes"
    case t('dashboard.kpi.otp'):
      return "ontimeperformance"
    case t('dashboard.kpi.kmpct'):
      return "kmpct"
    case t('dashboard.kpi.hpct'):
      return "hpct"
    case t('dashboard.kpi.tripspct'):
      return "tripspct"
  }

}